import { Button, Col, Input, Row } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import { ChangeEvent } from "react";
import { LolEntity, View } from "../../../types/views";

export interface EditLolViewProps {
  view: View;
  onEntityChange: (index: number, entity: LolEntity) => void;
  onViewNameChange: (name: string) => void;
  onAddEntity: () => void;
  onDeleteEntity: (index: number) => void;
}

const EditLolView = (props: EditLolViewProps) => {
  const {
    view,
    onEntityChange,
    onViewNameChange,
    onAddEntity,
    onDeleteEntity,
  } = props;

  const handleLolEntityChange = (
    field: keyof LolEntity,
    value: ChangeEvent<HTMLInputElement>,
    index: number,
    entity: LolEntity
  ) => {
    const updatedEntity = { ...entity, [field]: value.target.value };
    onEntityChange(index, updatedEntity);
  };

  return (
    <div>
      <Row>
        <Col span={12}>Name</Col>
        <Col span={12}>
          <Input
            value={view.name}
            onChange={(e) => onViewNameChange(e.target.value)}
          />
        </Col>
      </Row>
      <Row>
        <Col span={12}>Summoner Name</Col>
        <Col span={12}>Tag</Col>
      </Row>
      <hr />
      {view.entities.map((entity, i) => {
        const lolEntity = entity as LolEntity;
        return (
          <Row key={lolEntity.id}>
            <Col span={11}>
              <Input
                value={lolEntity.name}
                onChange={(value: ChangeEvent<HTMLInputElement>) =>
                  handleLolEntityChange("name", value, i, lolEntity)
                }
              />
            </Col>
            <Col span={10}>
              <Input
                style={{ marginLeft: "3px" }}
                value={lolEntity.tag}
                onChange={(value: ChangeEvent<HTMLInputElement>) =>
                  handleLolEntityChange("tag", value, i, lolEntity)
                }
              />
            </Col>
            <Col span={1} />
            <Col span={2}>
              <Button
                danger
                icon={<DeleteOutlined />}
                onClick={() => onDeleteEntity(i)}
              />
            </Col>
          </Row>
        );
      })}
      <Row>
        <Button style={{ marginTop: "5px" }} onClick={onAddEntity}>
          Add summoner
        </Button>
      </Row>
    </div>
  );
};

export default EditLolView;
